import { baseService } from 'sgm-dms-vue-menu';
import AppUrls from '@/urls';
import { cloneDeep } from 'lodash';

const Base = {
    // 按条件检索卡券类型
    dictType (type, data) {
        const DICT_TYPE = cloneDeep(AppUrls.BASE.DICT_TYPE);
        DICT_TYPE.path = DICT_TYPE.path + type;
        return baseService(DICT_TYPE, { params: data });
    },
    // 经销商
    commonDealer (data) {
        return baseService(AppUrls.BASE.COMMON_DEALER, { params: data });
    },
    // 车系
    commonSeries (data) {
        return baseService(AppUrls.BASE.COMMON_SERIES, { params: data });
    },
    // 车系
    commonStore (data) {
        return baseService(AppUrls.BASE.COMMON_STORE, { params: data });
    },
    // 城市
    commonCity (data) {
        return baseService(AppUrls.BASE.COMMON_CITY, { params: data });
    },
    // 城市
    getQuestionnaire (data) {
        return baseService(AppUrls.BASE.GET_QUESTIONNAIRE, { params: data });
    },
    // 品牌
    getAuthorityDetail (data) {
        return baseService(AppUrls.BASE.GET_AUTHORITY_DETAIL, { params: data });
    },
    gettopicpage (data) {
        return baseService(AppUrls.BASE.GET_TOPIC_PAGE, { data: data });
    }
};

export default Base;
